<!-- eslint-disable default-case -->
<script >
import { ref, onMounted, onUnmounted, nextTick } from 'vue-demi';
import useCmpStyle from './useCmpStyle';
import useRank from './useRank';
import useAutoScroll from './useAutoScroll';
const __sfc_main = {};
__sfc_main.props = {
  theme: String,
  language: String,
  market: String,
  speed: Number,
  upDownColor: String,
  bgColor: String,
  lineColor: String,
  stockFontSize: Number,
  stockFontColor: String,
  stockFontFamily: String,
  stockPriceFontSize: Number,
  stockPriceFontFamily: String,
  trendFontSize: String,
  trendFontFamily: String,
  customStocklist: Array,
  sort_id: Number,
  count: Number,
  platform: String
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    usePageType
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  // 样式处理
  const {
    swiperWrapStyle,
    splitLineStyle,
    stockNameStyle,
    stockTrendStyle,
    riseFallColor
  } = useCmpStyle(props);
  // 榜单数据
  const {
    getRankList
  } = useRank(props);
  // 自动滚动
  const swiperWrapperRef = ref();
  const {
    initScroll
  } = useAutoScroll(swiperWrapperRef, props.speed);
  let interval = null;
  // 设置一个数组接着
  const stockList = ref([]);
  const init = async () => {
    stockList.value = await getRankList();
    nextTick(() => {
      initScroll(stockList);
    });
  };
  onMounted(async () => {
    await init();
    // 设置定时器, 5分钟拉更新一次数据
    interval = setInterval(async () => {
      await init();
    }, 3e5);
  });
  // 清除副作用
  onUnmounted(() => {
    interval && clearInterval(interval);
  });
  return {
    isPC,
    swiperWrapStyle,
    splitLineStyle,
    stockNameStyle,
    stockTrendStyle,
    riseFallColor,
    swiperWrapperRef,
    stockList
  };
};
export default __sfc_main;
</script>
<template>
    <div
        class="flow-scroll-quotes-container"
        :class="[isPC ? '' : 'flow-scroll-quotes-container-h5']"
    >
        <div class="swiper" ref="swiper" :style="swiperWrapStyle">
            <div class="swiper-wrapper" ref="swiperWrapperRef">
                <div class="swiper-slide" v-for="(item, index) in stockList" :key="'swiper-slide' + index">
                    <p class="slide-stock-name" :style="stockNameStyle">{{ item.name }}</p>
                    <div class="slide-stock-info" :class="[riseFallColor]">
                        <span
                            class="stock-price"
                            :class="{
                                rise: item.priceChange > 0,
                                fall: item.priceChange < 0,
                            }"
                            :style="stockPriceStyle"
                        >
                            {{ item.price }}
                        </span>
                        <span
                            class="stock-updown"
                            :class="{
                                rise: item.priceChange > 0,
                                fall: item.priceChange < 0,
                            }"
                            :style="stockTrendStyle"
                        >
                            {{ item.ratioPriceChange }}
                        </span>
                        <span
                            v-show="item.priceChange > 0 || item.priceChange < 0"
                            class="stock-icon"
                            :class="{
                                rise: item.priceChange > 0,
                                fall: item.priceChange < 0,
                            }"
                        >
                            <svg
                                t="1670399685740"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="6535"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                            >
                                <path
                                    d="M416 64h192c26.6 0 48 21.4 48 48v400h207.6c42.8 0 64.2 51.6 34 82L546 946c-18.8 18.8-49.2 18.8-68 0L126.6 594c-30.2-30.2-8.8-82 34-82H368V112c0-26.6 21.4-48 48-48z"
                                    p-id="6536"
                                ></path>
                            </svg>
                        </span>
                    </div>
                    <div class="split-line" :style="splitLineStyle"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import url(./index.less);
</style>
